export default __webpack_public_path__ + "static/media/more_dot_card_vertical.06db73be.svg";